import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import { API_BASE_URL } from '../../config/api';
import './MobileLanguagePage.css';

const FALLBACK = [
  { name: 'English', value: 'en' },
  { name: '简体中文', value: 'zh' },
  { name: 'Español', value: 'es' },
  { name: 'Русский', value: 'ru' },
  { name: 'Türkçe', value: 'tr' },
  { name: 'Português', value: 'pt' },
  { name: 'Italiano', value: 'it' },
  { name: 'Français', value: 'fr' },
  { name: 'Deutsch', value: 'de' },
  { name: 'Nederlands', value: 'nl' },
  { name: 'ไทย', value: 'th' },
  { name: '日本語', value: 'ja' },
  { name: 'Tiếng Việt', value: 'vi' },
  { name: '한국어', value: 'ko' },
  { name: 'Bahasa Indonesia', value: 'id' },
  { name: 'العربية', value: 'ar' }
];

export default function MobileLanguagePage() {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const { user, updateProfile } = useAuth();
  const [options, setOptions] = useState(FALLBACK);
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/settings/options/public/app_language`);
      if (!res.ok) throw new Error();
      const data = await res.json();
      const list = (data || [])
        .map((o) => ({ name: o.name, value: (o.value || o.name).trim() }))
        .filter((o) => o.name && o.value);
      if (list.length) {
        setOptions(list);
      }
    } catch (_) {
      setOptions(FALLBACK);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const current =
    (user && user.appLanguage) ||
    (i18n.language || 'en').split('-')[0];

  const select = async (code) => {
    if (saving) return;
    setSaving(true);
    try {
      const short = (code || 'en').split('-')[0];
      localStorage.setItem('language', short);
      await i18n.changeLanguage(short);
      if (user) {
        await updateProfile({ appLanguage: short });
      }
      navigate(-1);
    } catch (e) {
      console.error(e);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="mlang-page">
      <div className="mlang-header">
        <button type="button" className="mlang-back" onClick={() => navigate(-1)} aria-label="Back">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2.2">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <h1 className="mlang-title">Language</h1>
      </div>
      <div className="mlang-list">
        {options.map((o) => {
          const isOn = current === o.value || current === o.value?.split('-')[0];
          return (
            <button
              key={o.value + o.name}
              type="button"
              className="mlang-row"
              onClick={() => select(o.value)}
              disabled={saving}
            >
              <span className={isOn ? 'mlang-radio mlang-radio--on' : 'mlang-radio'}>
                {isOn && <span className="mlang-dot" />}
              </span>
              <span className="mlang-name">{o.name}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
